import { IOrderAddressDto } from '../interface/IUserInfoDto'

export const OrderAddressDto: IOrderAddressDto = {
  id: '',
  orderId: '',
  addressId: '',
  address1: '',
  lat: 0,
  lng: 0,
  contact: '',
  phone: '',
  houseNumber: '',
  route: '',
  locality: '',
  administrativeAreaLevel1: '',
  country: '',
  postalCode: '',
  tag: ''
}
